<template>
  <apex-chart height="100%" width="100%" type="bar" :series="datatype.chart.series" :key="datatype.chart.series.length" :options="getOptions()"></apex-chart>
</template>

<script>
export default {
  props: {
    datatype: null,
    colors: null,
  },
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {
    getOptions() {
      /** @type {ApexCharts.ApexOptions} */
      var chartOptions = {
        colors: this.colors ? this.colors : [this.Colors.IconColor],
        chart: {
          width: "100%",
          type: "bar",
          stacked: false,
          defaultLocale: "bg",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          locales: [
            {
              name: "bg",
              options: {
                months: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
                shortMonths: ["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"],
                days: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
                shortDays: ["Нед", "Пон", "Вт", "Ср", "Чет", "Пет", "Съб"],
              },
              toolbar: {
                menu: "Изтегляне на изображение",
                exportToPNG: "Изтегляне в PNG формат",
                exportToSVG: "Изтегляне в SVG формат",
                exportToCSV: "Изтегляне в CSV формат",
                selection: "Избор",
                selectionZoom: "Режим на мащаб",
                zoomIn: "Увеличаване на мащаба",
                zoomOut: "Намаляване на мащаба",
                pan: "Режим на движение",
                reset: "Нулиране на мащаба",
              },
            },
          ],
        },
        title: {
          text: this.datatype.chart.title,
          align: "left",
          style: {
            fontSize: 18,
            fontFamily: "Roboto",
            fontWeight: "regular",
          },
        },
        theme: {
          mode: this.$vuetify.theme.global.name,
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        animations: {
          speed: 100,
          animateGradually: {
            delay: 0,
          },
        },
        fill: {
          type: "gradient",
        },
        xaxis: {
          type: "category",
          tickPlacement: "between",
          categories: this.datatype.chart.categories,
          labels: {
            show: false, //?
            formatter: this.datatype.chart.formatterX,
          },
        },
        yaxis: {
          labels: {
            show: true,
            formatter: this.datatype.chart.formatterY,
          },
        },
        labels: this.datatype.chart.categories,
        dataLabels: {
          background: {
            enabled: true,
            foreColor: this.Colors.Background,
            opacity: 0,
          },
          enabled: false,
          formatter: this.datatype.chart.formatterX,
        },
        tooltip: {
          enabled: !this.hideTooltips,
          theme: this.$vuetify.theme.global.name,
          y: {
            formatter: this.datatype.chart.formatterY,
            title: {
              formatter: this.datatype.chart.formatterTooltip,
            },
          },
        },
        legend: {
          show: false,
          // fontSize: 14,
          // fontFamily: "Roboto",
          // position: "left",
          // horizontalAlign: "left",
          // offsetY: this.isOnMobile ? 40 : 60,
          // itemMargin: {
          //   vertical: 10,
          // },
          // //   height: 140,
          // //   width: 180,
          // //   offsetX: 80,
        },
        responsive: [
          {
            breakpoint: 200,
          },
        ],
      };
      return chartOptions;
    },
  },
};
</script>

<style scoped>
* /deep/ .apexcharts-legend-text {
  align-content: end;
  white-space: pre-wrap !important;
}
</style>